
export function sendRequest(email){
	fetch('/.netlify/functions/sendEmail', {
		method: 'post',
		body: JSON.stringify(email)
	});
};